import { Spinner, Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { DashboardApi, EDepartment } from "../../../api";
import { BackButton, PageBase, ProtectedTabs } from "../../../components";
import { ERoutes } from "../../../ERoutes";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { AccountingTaskList } from "../accounting/AccountingTaskList";
import { DogAwaitingUpdateTaskList } from "../dogUpdate/DogAwaitingUpdateTaskList";
import { DogHealth } from "../health/DogHealthDashboardPage";
import { DashboardSportPage } from "../sport/DashboardSportPage";
import { DogTransientTitlesList } from "../sport/DogTransientTitlesList";
import { UnassignedRequestList } from "./UnassignedRequestList";

export interface IUnassignedRequestItemPageProps {}

export const UnassignedRequestItemPage: React.FunctionComponent<IUnassignedRequestItemPageProps> = (props) => {
  const history = useHistory();
  const api = useApiService(DashboardApi);
  const { t } = useTl();
  const { tab } = useParams<{
    tab: string;
  }>();

  const [data, loading] = useApiEffect(() => api.getuserDepartements());

  React.useEffect(() => {
    if (!tab) history.push(`${ERoutes.unassignedRequests}/unassigned`);
  }, [history, tab]);

  return loading ? (
    <Spinner />
  ) : (
    <PageBase
      breadCrumbs={[
        {
          text: t(ETLCodes.UnassignedRequests),
          route: ERoutes.unassignedRequests,
        },
      ]}
    >
      <ProtectedTabs
        id="TabsUnassignedRequests"
        onChange={(newTabId) => history.push(`${ERoutes.unassignedRequests}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.unassignedRequests} />
        <Tab id="unassigned" title={t(ETLCodes.Requests)} panel={<UnassignedRequestList departementCode={null} />} />
        <Tab id="affix" title={t(ETLCodes.RequestAffix)} panel={<></>} disabled />
        <Tab
          id="compatibily"
          title={t(ETLCodes.Compatibility)}
          panel={<AccountingTaskList isAssigned={false} />}
          disabled={!data?.includes(EDepartment.Accounting)}
        />
        <Tab
          id="updateDog"
          title={t(ETLCodes.DogUpdate)}
          panel={<DogAwaitingUpdateTaskList isAssigned={false} sportSection={false} />}
        />
        <Tab
          id="pedigree"
          title={t(ETLCodes.Pedigree)}
          panel={<DogTransientTitlesList searchUnassignedTitles={true} />}
        />
        <Tab
          id="health"
          title={t(ETLCodes.Health)}
          panel={<DogHealth searchUnassigned={true} />}
          disabled={!data?.includes(EDepartment.Health)}
        />
        <Tab
          id="sport"
          title={t(ETLCodes.Sport)}
          panel={
            <div>
              <DashboardSportPage searchUnassignedTitles />
              <DogAwaitingUpdateTaskList isAssigned={false} sportSection />
            </div>
          }
          disabled={!data?.includes(EDepartment.Sport)}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
